import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classes from './style.module.scss';

function StatusField({ status, className = '' }) {
  let statusClass = '';

  if (status.toLowerCase().includes('prior auth')) {
    statusClass = 'prior';
  } else if (status.toLowerCase().includes('copay')) {
    statusClass = 'copay';
  } else if (status.toLowerCase().includes('progress')) {
    statusClass = 'progress';
  } else if (status.toLowerCase().includes('on hold')) {
    statusClass = 'hold';
  } else if (status.toLowerCase().includes('not started')) {
    statusClass = 'not_started';
  }

  return (
    <div className={`${classes.statusStyle} ${classes[(statusClass || status).toLowerCase()]} ${className}`}>
      <p>{_.startCase(status)}</p>
    </div>
  );
}

StatusField.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusField;
